module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-minus-fill-75b6e051.svg";